<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/MasterShopOnOff'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
                v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label class="label-required">ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                        :css-style="'width: 100%;'"
                        :css-class="'form-control m-select2'"
                        :id="'reAgentCodes'"
                        :name="'reAgentCodes'"
                        :select2-options="reAgentCodesOptions"
                        v-model="reAgentCodes"
                        ref="reAgentCodesSelect2"
                        multiple
                    ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    v-on:open="LoadreAgentCodesOptions"
                    v-on:select="SelectedAgentCodes"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                    @input="updateValueAgentCodes"
                  />
                  <span
                    class="form-text"
                    style="color: #fd397a;"
                    v-show="AgentCodesMessagesStatus == true"
                    >{{ AgentCodesMessages }}</span
                  >
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
              v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopCodes'"
                    :name="'reShopCodes'"
                    :select2-options="reShopCodesOptions"
                    v-model="reShopCodes"
                    ref="reShopCodesSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reShopCodes"
                    :multiple="true"
                    :load-options="LoadreShopCodesOptions"
                    :async="true"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              

              <!-- <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ร้านค้า 2:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopCodes2'"
                    :name="'reShopCodes2'"
                    :select2-options="reShopCodes2Options"
                    v-model="reShopCodes2"
                    ref="reShopCodes2Select2"
                    multiple
                  ></select2>
                </div>
              </div> -->



              
              
            </div>

            <div class="row" > 
            <!-------ตัวแทนจำหน่ายย่อย---->
            <div  
            v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                "

            class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
 
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentShopCodes'"
                    :name="'pmrSubAgentShopCodes'"
                    :select2-options="pmrSubAgentShopCodesOptions"
                    v-model="pmrSubAgentShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
                  >
                    *ควรเลือกตัวแทนจำหน่ายย่อยด้วย
                  </p>
                </div>
              </div>
            <!-------สิ้นสุดตัวแทนจำหน่ายย่อย-->

            <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    v-on:select="ClearAgentCodesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

            </div>

              
              <div class="row"> 

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group ">
                  <label class="label">ข้อมูลระหว่างวันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ข้อมูลระหว่างวันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect
                    v-model="reShopTypeId"
                    :multiple="true"
                    :options="reShopTypeIdOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopGroupId"
                    :multiple="true"
                    :options="shmShopGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทการล้างเครื่อง:</label>
                  <treeselect
                    v-model="shmShopPMType"
                    :multiple="true"
                    :options="shmShopPMTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopStatus'"
                    :name="'reShopStatus'"
                    :select2-options="reShopStatusOptions"
                    v-model="reShopStatus"
                    ref="reShopStatusSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เหตุผล:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reReason'"
                    :name="'reReason'"
                    :select2-options="reReasonOptions"
                    v-model="reReason"
                    ref="reReasonSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reReason"
                    :multiple="true"
                    :options="reReasonOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เลือกเหตุผล:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    
                  ></select2>
                </div>
              </div> -->

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reProvinceId'"
                    :name="'reProvinceId'"
                    :select2-options="reProvinceIdOptions"
                    v-model="reProvinceId"
                    ref="reProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAmpherId'"
                    :name="'reAmpherId'"
                    :select2-options="reAmpherIdOptions"
                    v-model="reAmpherId"
                    ref="reAmpherIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="reInActiveStatus"
                        name="reInActiveStatus"
                        v-model="reInActiveStatus"
                        @click="FncreInActiveStatus"
                        type="checkbox"
                        class="form-check-input"
                      />
                      สถานะปัจจุบัน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            
            <div class="row mb-3">
              <div
                class="col-xl-6"
                v-if="
                  this.$root.canShow([
                    // 'AGENT_REPORT', 'SUB_AGENT_REPORT', 'BR_REPORT',
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportMasterShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      AgentCodesMessages: "กรุณาเลือกตัวแทนจำหน่าย",
      AgentCodesMessagesStatus: false,
      reAllAgentCodes : [],
      reAgentCodes: [],
      reShopCodes: [],
      reShopCodes2: [],
      reDepartments: [],
      reStartDate: null,
      reEndDate: null,
      reShopTypeId: [],
      shmShopGroupId: [],
      shmShopPMType : [],
      reShopStatus: null,
      reProvinceId: null,
      reAmpherId: null,
      reReason: [],
      reInActiveStatus: true,
      reAgentCodesOptions: [],

      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],
      pmrSubAgentShopCodes : [],
      pmrSubAgentShopCodesOptions : [],
      
      // reAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         agentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      // reShopCodesOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/Select2ShopAgent",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         agentCodes: self.reAgentCodes,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reShopCodes: [],
      reShopCodesOptions: [],
      reShopCodes2Options: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgentName2",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.reAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      
      pmrSubAgentShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         //pmrSubAgentCodes
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.reAgentCodes, 
              shopCodes  : self.pmrSubAgentCodes,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {

            var isAllAgent = false ;
            if(self.reAgentCodes.indexOf("99999999") > -1){ 
                  isAllAgent = true;
                  self.reAllAgentCodes = [] ;
                  self.reAgentCodesOptions.forEach((element) => {
                      self.reAllAgentCodes.push(element.id);
                    }); 
                }
                else{
                  self.reAllAgentCodes = [];
                }  
 
              
            var query = {
              agentCodes: (isAllAgent) ?  self.reAllAgentCodes  : self.reAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 

      reDepartmentsOptions: [],
      // reDepartmentsOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเขตการขาย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reReasonOptions: [],
      // reReasonOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select25Reason",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         isActive: self.reShopStatus,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reShopTypeIdOptions: [],
      shmShopGroupIdOptions: [],
      shmShopPMTypeOptions : [],
      // reShopTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ShopType/Select2SearchShopType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: true, text: "ร้านเปิด", data: null },
          { id: false, text: "ร้านปิด", data: null },
        ],
      },
      reProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.reProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reAgentCodes = [];
      self.reShopCodes = [];
      self.reShopCodes2 = [];
      self.reDepartments = [];
      self.reStartDate = null;
      self.reEndDate = null;
      self.reShopTypeId = [];
      self.shmShopGroupId = [];
      self.shmShopPMType = [];
      self.reShopStatus = null;
      self.reProvinceId = null;
      self.reAmpherId = null;
      self.reReason = [];
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentCodeOptions = [];
      self.pmrSubAgentShopCodes = [];
      self.pmrSubAgentShopCodesOptions = [];

      $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");
        
        $("#pmrSubAgentShopCodes")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

      $("#reShopCodes")
        .val("")
        .trigger("change");

      $("#reShopCodes2")
        .val("")
        .trigger("change");

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      $("#reShopTypeId")
        .val("")
        .trigger("change");

      $("#shmShopGroupId")
        .val("")
        .trigger("change");

        $("#shmShopPMType")
        .val("")
        .trigger("change");
        

      $("#reShopStatus")
        .val("")
        .trigger("change");

      $("#reProvinceId")
        .val("")
        .trigger("change");

      $("#reAmpherId")
        .val("")
        .trigger("change");

      $("#reReason")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      console.log("formSubmit");
      let self = this;

      e.preventDefault();
      table.draw();
    },
    exportMasterShop: function(e) {
      e.preventDefault();
      let self = this;

      self.AgentCodesMessagesStatus = false;

      if (
        this.$root.canShow([
          "super_admin",
          "ADMIN_PM",
          "AGENT_ADMIN_PM", 
          "COOL_SERVICE_PM",
        ])
      ) {
        if (self.reAgentCodes.length == 0) {
          self.AgentCodesMessagesStatus = true;
        }
      }

      var isAllAgent = false ;
      if(self.reAgentCodes.indexOf("99999999") > -1){ 
             isAllAgent = true;
             self.reAgentCodesOptions.forEach((element) => {
                self.reAllAgentCodes.push(element.id);
              }); 
          }
          else{
            self.reAllAgentCodes = [];
          }   
      if (self.AgentCodesMessagesStatus == false) {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
        });

        axios({
          method: "post",
          url: "/Api/Report/ExportMasterShop",
          responseType: "arraybuffer",
          data: {
            AgentCode: (isAllAgent) ? self.reAllAgentCodes : self.reAgentCodes,
            ShopCode1: self.reShopCodes,
            ShopCode2: self.reShopCodes2,
            Department: self.reDepartments,
            ShopType: self.reShopTypeId,
            ShopGroup: self.shmShopGroupId,
            ShopPMType: self.shmShopPMType,
            Status: self.reShopStatus,
            ProvinceId: self.reProvinceId,
            AmperId: self.reAmpherId,
            SubAgentShopIds: self.pmrSubAgentShopCodes, 
            SubAgentCodes: self.pmrSubAgentCodes  , 
            StartDate:
              self.reStartDate != null
                ? self.reStartDate.format("DD/MM/YYYY")
                : self.reStartDate,
            EndDate:
              self.reEndDate != null
                ? self.reEndDate.format("DD/MM/YYYY")
                : self.reEndDate,
            InActiveStatus: !self.reInActiveStatus,
            Reason: self.reReason,
          },
        })
          .then(function(response) {
            if (response.status == "200") {
              let filename = "";
              let contentType = response.headers["content-type"];
              let disposition = response.headers["content-disposition"];

              //===Get Filename===
              if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, "");
                }
              }

              var fname = filename.split("RPT_")[1] ;   

              //Save file
              let blob = new Blob([response.data], { type: contentType });
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
             // link.download = filename;
              link.download = "ข้อมูลร้านค้า_" + fname//+ filename;
              link.click();
            } else if (response.status == "204") {
              Swal.fire(
                "ไม่พบข้อมูล",
                "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
                "warning"
              );
            }
          })
          .catch(function(error) {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          })
          .then(function() {
            //self.formReset();
            KTApp.unblockPage();
          });
      }
      // else {
      //   self.AgentCodesMessagesStatus = true;
      //   return false;
      // }
    },
    SelectedAgentCodes : function(e){
      var self = this;
     // self.reAgentCodes = [];
      // setTimeout(function() {
      //      alert(self.reAgentCodes);

      //      if(self.reAgentCodes.indexOf("99999999") > -1){
            
      //      self.reAgentCodesOptions.forEach((element) => {
      //       self.reAllAgentCodes.push(element.id);
      //       });

      //     }
      //     else{
      //       self.reAllAgentCodes = [];
      //     }
          
      //     alert(self.reAgentCodes);

            
      //   }, 100);
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      self.reAgentCodesOptions = [
        { id: "", label: "Loading...", isDisabled: true },
      ]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      axios
        .post("/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM", {
          province_id: [],
          department: self.reDepartments,
          agentCodes: [],
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            if (self.reDepartments.length == 0) {
              self.reAgentCodesOptions = [{ id: "99999999", label: "ทั้งหมด" }];
            } else {
              self.reAgentCodesOptions = [];
            }
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
                isDisabled: self.reAgentCodes[0] == "" ? true : false,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreDepartmentsOptions: function(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reDepartmentsOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreReasonOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select25Reason", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reReasonOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadShopGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadshmShopPMTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopPMTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    LoadreShopCodesOptions({ action, searchQuery, callback }) {
      var self = this;

      if (action === ASYNC_SEARCH) {
        self.reShopCodesOptions = [];

        var inActiveStatus = null;
        if (self.reShopStatus == "true") inActiveStatus = false;
        else if (self.reShopStatus == "false") inActiveStatus = true;

        if (self.reAgentCodes.length > 0) {
          axios
            .post("/Api/Report/Select2BarButlerShop", {
              Page: 1,
              All: true,
              Search: searchQuery,
              AgentCodes: self.reAgentCodes,
              InActiveStatus: inActiveStatus,
            })
            .then(function(response) {
              if (response.status == 200) {
                var data = response.data.results;
                self.reShopCodesOptions = [];
                data.forEach((element) => {
                  self.reShopCodesOptions.push({
                    id: element.id,
                    label: element.text,
                  });
                });
                callback(null, self.reShopCodesOptions);
              }
            })
            .catch(function(error) {});
        } else {
          console.log("else LoadreShopCodesOptions");
          self.reShopCodesOptions = [];
          callback(null, self.reShopCodesOptions);
        }
      }
    },
    updateValueAgentCodes: function(e) {
      this.reShopCodes = [];
      this.reShopCodesOptions = [];
      this.LoadreShopCodesOptions("ASYNC_SEARCH", "", null);
    },
    ClearAgentCodesOptions: function(e) {
      this.reAgentCodes = [];
    },
    FncreInActiveStatus: function(e) {
      // var options = [];
      $("#reShopStatus").html(null);
      if ($(`#reInActiveStatus`).is(":checked")) {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: false,
          data: [{ id: true, text: "ร้านเปิด", data: null }],
        });
        this.reShopStatus = true;
      } else {
        $("#reShopStatus").select2({
          placeholder: "ทั้งหมด",
          allowClear: true,
          data: [
            { id: true, text: "ร้านเปิด", data: null },
            { id: false, text: "ร้านปิด", data: null },
          ],
        });
        this.reShopStatus = true;
      }
    },
  },
  async mounted() {
    let self = this;

    self.LoadreAgentCodesOptions();
    self.LoadreDepartmentsOptions();
    self.LoadreReasonOptions();
    self.LoadreShopTypeIdOptions();
    self.LoadShopGroupIdOptions();
    self.LoadshmShopPMTypeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }
    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    
   // if( self.$root.canShow([ "ADMIN_PM", "AGENT_ADMIN_PM",  "COOL_SERVICE_PM", ]))

    $(this.$refs.form).validate({
      rules: {
        reAgentCodes: "required",
      },
      messages: {
        reAgentCodes: "กรุณาเลือกตัวแทนจำหน่าย",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";

    this.$refs.reShopStatusSelect2.setSelectedData({
      id: true,
      text: "ร้านเปิด",
      data: null,
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/MasterShopOnOff.vue